import { render, staticRenderFns } from "./rewardPickOneEdit.vue?vue&type=template&id=2470a233&scoped=true&"
import script from "./rewardPickOneEdit.vue?vue&type=script&lang=js&"
export * from "./rewardPickOneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470a233",
  null
  
)

export default component.exports